import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
var commonStyles = css(["", " ", " ", " ", " ", " ", " ", ""], function (props) {
  return props.responsive && "\n\t\tdisplay: block;\n\t\tmax-width: 100%;\n\t\theight: auto;\n\t";
}, function (props) {
  return props.rounded && "\n\t\tborder-radius: ".concat(props.rounded, "px;\n\t");
}, function (props) {
  return props.opacity && "\n\t\topacity: ".concat(props.opacity, ";\n\t\tfilter: alpha(opacity=").concat(props.opacity * 100, ");\n\t");
}, function (props) {
  return props.filter && "\n\t\tfilter: ".concat(props.filter, ";\n\t");
}, function (props) {
  return props.imageWidth && "\n\t\twidth: ".concat(props.imageWidth, ";\n\t");
}, function (props) {
  return props.imageHeight && "\n\t\theight: ".concat(props.imageHeight, ";\n\t");
}, function (props) {
  return props.onClick && "\n\t\tcursor: pointer;\n\t";
});
var StyledImage = styled.img.withConfig({
  displayName: "style__StyledImage",
  componentId: "sc-2ccwro-0"
})(["", " ", ""], commonStyles, function (props) {
  return props.fitCover && "\n\t\tobject-fit: cover;\n\t";
});
var StyledSVG = styled(SVG).withConfig({
  displayName: "style__StyledSVG",
  componentId: "sc-2ccwro-1"
})(["svg{", " ", " ", "}"], commonStyles, function (props) {
  return props.width && "\n\t\t\twidth: ".concat(props.width, ";\n\t\t");
}, function (props) {
  return props.height && "\n\t\t\theight: ".concat(props.height, ";\n\t\t");
});
var StyledNonSVG = styled.div.withConfig({
  displayName: "style__StyledNonSVG",
  componentId: "sc-2ccwro-2"
})(["", " ", " ", " ", " ", " ", ""], commonStyles, function (props) {
  return props.width && "\n\t\twidth: ".concat(props.width, ";\n\t");
}, function (props) {
  return props.height && "\n\t\theight: ".concat(props.height, ";\n\t");
}, function (props) {
  return props.color && "\n\t\tbackground-color: ".concat(props.color, ";\n\t");
}, function (props) {
  return props.src && "\n\t\tmask: url(".concat(props.src, ") no-repeat center;\n\t");
}, function (props) {
  return props.fitCover && "\n\t\tobject-fit: cover;\n\t";
});
export { StyledImage, StyledSVG, StyledNonSVG };